// extracted by mini-css-extract-plugin
module.exports = {"container":"OpportunityUpdate_container__2Oz82","form":"OpportunityUpdate_form__2cjSl"};